/** Default ticket list filters (all statuses except Closed). */
export const DEFAULT_TICKET_LIST_FILTERS = {
  status: [1, 2, 3, 5],
  category: [],
  creator: [],
  technician: [],
};

export const DASHBOARD_TICKET_FILTERS_STORAGE_KEY =
  'ithelpdesk.dashboard.ticketFilters';

export const TECHNICIAN_VIEW_TICKET_FILTERS_STORAGE_KEY =
  'ithelpdesk.technicianView.ticketFilters';

const isArray = (value) => Array.isArray(value);

/**
 * @param {string} storageKey
 * @param {{ includeTeamId?: boolean }} [options]
 */
export function loadTicketListFilters(storageKey, options = {}) {
  const { includeTeamId = false } = options;
  const fallback = {
    ...DEFAULT_TICKET_LIST_FILTERS,
    ...(includeTeamId ? { teamId: null } : {}),
  };

  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) {
      return fallback;
    }

    const parsed = JSON.parse(raw);
    const loaded = {
      status: isArray(parsed.status)
        ? parsed.status
        : DEFAULT_TICKET_LIST_FILTERS.status,
      category: isArray(parsed.category) ? parsed.category : [],
      creator: isArray(parsed.creator) ? parsed.creator : [],
      technician: isArray(parsed.technician) ? parsed.technician : [],
    };

    if (includeTeamId) {
      loaded.teamId =
        parsed.teamId === null || parsed.teamId === undefined
          ? null
          : parsed.teamId;
    }

    return loaded;
  } catch {
    return fallback;
  }
}

/** @param {string} storageKey */
export function saveTicketListFilters(storageKey, filters) {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(filters));
  } catch {
    // Ignore quota or private-mode errors — filters still work for this visit.
  }
}
